import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as storage from '../../../persistance/storage';
import isLoggedIn, {isGM} from '../../../utils/auth';

import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

import {nameValidation, emailValidation, phoneValidation, streetValidation, cityValidation, zipValidation, textValidation, dateValidation, selectValidation} from '../../../utils/itemValidation';
import {displayPhoneInput, displayDateInput, stringToDigits, dayMonthToDbDate} from '../../../utils/formatting';

import CustomerCardSubmit from '../../common/alert/CustomerCardSubmit';
import RhinoSelect from '../../common/inputs/RhinoSelect';

import * as commonActionCreators from '../../../actions/common';
import * as leadsActionCreators from '../../../actions/leads';
import * as storesActionCreators from '../../../actions/stores';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, leadsActionCreators, storesActionCreators, usersActionCreators);

class CustomerProfile extends React.Component {


	constructor(props) {
		super(props);

    let locationOptions = [
      { display: 'Loading locations...', value: '' },
    ];

    let associateOptions = [
      { display: 'Sales Associate (please select location first)', value: '' },
    ];

    this.initAssociateOptions = associateOptions;

    let stateOptions = [
      { display: 'STATE', value: '' },
      { display: "Alabama", value: "AL" },
      { display: "Alaska", value: "AK" },
      { display: "Arizona", value: "AZ" },
      { display: "Arkansas", value: "AR" },
      { display: "California", value: "CA" },
      { display: "Colorado", value: "CO" },
      { display: "Connecticut", value: "CT" },
      { display: "Delaware", value: "DE" },
      { display: "District Of Columbia", value: "DC" },
      { display: "Florida", value: "FL" },
      { display: "Georgia", value: "GA" },
      { display: "Hawaii", value: "HI" },
      { display: "Idaho", value: "ID" },
      { display: "Illinois", value: "IL" },
      { display: "Indiana", value: "IN" },
      { display: "Iowa", value: "IA" },
      { display: "Kansas", value: "KS" },
      { display: "Kentucky", value: "KY" },
      { display: "Louisiana", value: "LA" },
      { display: "Maine", value: "ME" },
      { display: "Maryland", value: "MD" },
      { display: "Massachusetts", value: "MA" },
      { display: "Michigan", value: "MI" },
      { display: "Minnesota", value: "MN" },
      { display: "Mississippi", value: "MS" },
      { display: "Missouri", value: "MO" },
      { display: "Montana", value: "MT" },
      { display: "Nebraska", value: "NE" },
      { display: "Nevada", value: "NV" },
      { display: "New Hampshire", value: "NH" },
      { display: "New Jersey", value: "NJ" },
      { display: "New Mexico", value: "NM" },
      { display: "New York", value: "NY" },
      { display: "North Carolina", value: "NC" },
      { display: "North Dakota", value: "ND" },
      { display: "Ohio", value: "OH" },
      { display: "Oklahoma", value: "OK" },
      { display: "Oregon", value: "OR" },
      { display: "Pennsylvania", value: "PA" },
      { display: "Puerto Rico", value: "PR" },
      { display: "Rhode Island", value: "RI" },
      { display: "South Carolina", value: "SC" },
      { display: "South Dakota", value: "SD" },
      { display: "Tennessee", value: "TN" },
      { display: "Texas", value: "TX" },
      { display: "Utah", value: "UT" },
      { display: "Vermont", value: "VT" },
      { display: "Virginia", value: "VA" },
      { display: "Washington", value: "WA" },
      { display: "West Virginia", value: "WV" },
      { display: "Wisconsin", value: "WI" },
      { display: "Wyoming", value: "WY" }
    ];

    let hearAboutOptions = [
      { display: 'HOW DID YOU HEAR ABOUT US', value: '' },
      { display: 'Previous customer', value: 'Previous customer' },
      { display: 'Friend/family recommendation', value: 'Recommendation' },
      { display: 'Search engine', value: 'Search engine' },
      { display: 'Online advertisement', value: 'Online' },
      { display: 'Radio advertisement', value: 'Radio' },
      { display: 'Other', value: 'Other' },
    ];

    let customerSizeOptions = [
      { display: 'CUSTOMER FINGER SIZE', value: '' },
      { display: '3', value: '3' },
      { display: '3.25', value: '3.25' },
      { display: '3.5', value: '3.5' },
      { display: '3.75', value: '3.75' },
      { display: '4', value: '4' },
      { display: '4.25', value: '4.25' },
      { display: '4.5', value: '4.5' },
      { display: '4.75', value: '4.75' },
      { display: '5', value: '5' },
      { display: '5.25', value: '5.25' },
      { display: '5.5', value: '5.5' },
      { display: '5.75', value: '5.75' },
      { display: '6', value: '6' },
      { display: '6.25', value: '6.25' },
      { display: '6.5', value: '6.5' },
      { display: '6.75', value: '6.75' },
      { display: '7', value: '7' },
      { display: '7.25', value: '7.25' },
      { display: '7.5', value: '7.5' },
      { display: '7.75', value: '7.75' },
      { display: '8', value: '8' },
      { display: '8.25', value: '8.25' },
      { display: '8.5', value: '8.5' },
      { display: '8.75', value: '8.75' },
      { display: '9', value: '9' },
      { display: '9.25', value: '9.25' },
      { display: '9.5', value: '9.5' },
      { display: '9.75', value: '9.75' },
      { display: '10', value: '10' },
      { display: '10.25', value: '10.25' },
      { display: '10.5', value: '10.5' },
      { display: '10.75', value: '10.75' },
      { display: '11', value: '11' },
      { display: '11.25', value: '11.25' },
      { display: '11.5', value: '11.5' },
      { display: '11.75', value: '11.75' },
      { display: '12', value: '12' },
      { display: '12.25', value: '12.25' },
      { display: '12.5', value: '12.5' },
      { display: '12.75', value: '12.75' },
      { display: '13', value: '13' },
      { display: '13.25', value: '13.25' },
      { display: '13.5', value: '13.5' },
      { display: '13.75', value: '13.75' },
      { display: '14', value: '14' },
    ];

    let soSizeOptions = [
      { display: 'SIGNIFICANT OTHER FINGER SIZE', value: '' },
      { display: '3', value: '3' },
      { display: '3.25', value: '3.25' },
      { display: '3.5', value: '3.5' },
      { display: '3.75', value: '3.75' },
      { display: '4', value: '4' },
      { display: '4.25', value: '4.25' },
      { display: '4.5', value: '4.5' },
      { display: '4.75', value: '4.75' },
      { display: '5', value: '5' },
      { display: '5.25', value: '5.25' },
      { display: '5.5', value: '5.5' },
      { display: '5.75', value: '5.75' },
      { display: '6', value: '6' },
      { display: '6.25', value: '6.25' },
      { display: '6.5', value: '6.5' },
      { display: '6.75', value: '6.75' },
      { display: '7', value: '7' },
      { display: '7.25', value: '7.25' },
      { display: '7.5', value: '7.5' },
      { display: '7.75', value: '7.75' },
      { display: '8', value: '8' },
      { display: '8.25', value: '8.25' },
      { display: '8.5', value: '8.5' },
      { display: '8.75', value: '8.75' },
      { display: '9', value: '9' },
      { display: '9.25', value: '9.25' },
      { display: '9.5', value: '9.5' },
      { display: '9.75', value: '9.75' },
      { display: '10', value: '10' },
      { display: '10.25', value: '10.25' },
      { display: '10.5', value: '10.5' },
      { display: '10.75', value: '10.75' },
      { display: '11', value: '11' },
      { display: '11.25', value: '11.25' },
      { display: '11.5', value: '11.5' },
      { display: '11.75', value: '11.75' },
      { display: '12', value: '12' },
      { display: '12.25', value: '12.25' },
      { display: '12.5', value: '12.5' },
      { display: '12.75', value: '12.75' },
      { display: '13', value: '13' },
      { display: '13.25', value: '13.25' },
      { display: '13.5', value: '13.5' },
      { display: '13.75', value: '13.75' },
      { display: '14', value: '14' },
    ];

    // Load locations if not loaded
    if(this.props.stores.locations.length === 0) {
      this.props.fetchLocations()
      .then((respData) => {
        this.props.storeslocationsSave(respData.locations);

        let updatedLocationOptions = [
          { display: 'LOCATION*', value: '' },
        ];

        for(let i = 0; i < this.props.stores.locations.length; i++) {
          let singleLocation = {
            display: this.props.stores.locations[i].name,
            value: this.props.stores.locations[i].id,
          };
          if(singleLocation.display !== 'Headquarters') {
            updatedLocationOptions.push(singleLocation);
          }
        }

        this.setState({ locationOptions: updatedLocationOptions });

      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    } else {

      locationOptions = [
        { display: 'LOCATION*', value: '' },
      ];

      for(let i = 0; i < this.props.stores.locations.length; i++) {
        let singleLocation = {
          display: this.props.stores.locations[i].name,
          value: this.props.stores.locations[i].id,
        };
        if(singleLocation.display !== 'Headquarters') {
          locationOptions.push(singleLocation);
        }
      }
    }

    this.state = {

      successAlertOpen: false,
      sendingRequest: false,
      serverError: null,

      locationOptions: locationOptions,
      associateOptions: associateOptions,
      stateOptions: stateOptions,
      hearAboutOptions: hearAboutOptions,
      customerSizeOptions: customerSizeOptions,
      soSizeOptions: soSizeOptions,

      idValue: this.props.users.cardToEdit && this.props.users.cardToEdit.customer_number ? this.props.users.cardToEdit.customer_number : null,
      locationValue: this.props.users.cardToEdit && this.props.users.cardToEdit.store_number ? this.props.users.cardToEdit.store_number : '',
      associateValue: this.props.users.cardToEdit && this.props.users.cardToEdit.associate_id ? this.props.users.cardToEdit.associate_id : '',
      firstNameValue: this.props.users.cardToEdit && this.props.users.cardToEdit.firstName ? this.props.users.cardToEdit.firstName : '',
      lastNameValue: this.props.users.cardToEdit && this.props.users.cardToEdit.lastName ? this.props.users.cardToEdit.lastName : '',
      soFirstNameValue: this.props.users.cardToEdit && this.props.users.cardToEdit.significant_other_name ? this.props.users.cardToEdit.significant_other_name : '',
      phoneValue: this.props.users.cardToEdit && this.props.users.cardToEdit.phone ? this.props.users.cardToEdit.phone : '',
      emailValue: this.props.users.cardToEdit && this.props.users.cardToEdit.email ? this.props.users.cardToEdit.email : '',
      addressStreetValue: this.props.users.cardToEdit && this.props.users.cardToEdit.address ? this.props.users.cardToEdit.address : '',
      addressCityValue: this.props.users.cardToEdit && this.props.users.cardToEdit.addresses && this.props.users.cardToEdit.addresses.length ? this.props.users.cardToEdit.addresses[0].city : '',
      addressStateValue: this.props.users.cardToEdit && this.props.users.cardToEdit.addresses && this.props.users.cardToEdit.addresses.length ? this.props.users.cardToEdit.addresses[0].state : '',
      addressZipValue: this.props.users.cardToEdit && this.props.users.cardToEdit.addresses && this.props.users.cardToEdit.addresses.length ? this.props.users.cardToEdit.addresses[0].zipcode : '',
      birthdayValue: this.props.users.cardToEdit && this.props.users.cardToEdit.date_of_birth ? displayDateInput(this.props.users.cardToEdit.date_of_birth) : '',
      soBirthdayValue: this.props.users.cardToEdit && this.props.users.cardToEdit.spouses && this.props.users.cardToEdit.spouses.length ? displayDateInput(this.props.users.cardToEdit.spouses[0].birthdate) : '',
      weddingDateValue: this.props.users.cardToEdit && this.props.users.cardToEdit.anniversary_date ? displayDateInput(this.props.users.cardToEdit.anniversary_date) : '',
      hearAboutValue: this.props.users.cardToEdit && this.props.users.cardToEdit.hear_about ? this.props.users.cardToEdit.hear_about : '',
      referralValue: this.props.users.cardToEdit && this.props.users.cardToEdit.referral_name ? this.props.users.cardToEdit.referral_name : '',
      fingerSizeValue: this.props.users.cardToEdit && this.props.users.cardToEdit.app_ring_size ? this.props.users.cardToEdit.app_ring_size : '',
      soFingerSizeValue: this.props.users.cardToEdit && this.props.users.cardToEdit.spouses && this.props.users.cardToEdit.spouses.length && this.props.users.cardToEdit.spouses[0].finger_size ? this.props.users.cardToEdit.spouses[0].finger_size : '',
      notesValue: this.props.users.cardToEdit && this.props.users.cardToEdit.notes ? this.props.users.cardToEdit.notes : '',

      locationError: null,
      associateError: null,
      firstNameError: null,
      lastNameError: null,
      soFirstNameError: null,
      phoneError: null,
      emailError: null,
      addressStreetError: null,
      addressCityError: null,
      addressStateError: null,
      addressZipError: null,
      birthdayError: null,
      soBirthdayError: null,
      weddingDateError: null,
      hearAboutError: null,
      referralError: null,
      fingerSizeError: null,
      soFingerSizeError: null,
      notesError: null,
    }

    this.authToken = storage.get('token');
	}

  componentDidMount() {
    if(this.props.users.cardToEdit && this.props.users.cardToEdit.location_id) {
      this.updateAssociates(this.props.users.cardToEdit.location_id);
    }
  }

  componentWillUnmount() {
    this.props.setCustomerCardToEdit(null);
  }

  userNav(page) {
    history.push('/' + page);
  }

  convertDbDate(date_str) {

    if(date_str.length > 5) {
      return date_str.substring(5,7) + '/' + date_str.substring(8,10) + '/' + date_str.substring(0,4);  
    } else {
      return date_str;
    }
    
    return date_str;
  }

  getAscIdByDbId(dbId) {
    if(!this.props.stores.locations || this.props.stores.locations.length === 0) {
      return null;
    }
    for(const loc of this.props.stores.locations) {
      if(parseInt(loc.id) === parseInt(dbId)) {
        return loc.asc_id;
      }
    }
    return null;
  }

  changeLocation(evt) {

    this.setState({locationValue: evt.target.value}, () => {

      if(this.state.locationError !== null && this.state.locationValue !== '') {
        this.setState({locationError: null});
      }

      if(this.state.locationValue !== '') {

        // Fetch location
        let associateOptions = [
          { display: 'Loading...', value: '' },
        ];

        this.setState({ 
          associateOptions: associateOptions,
          associateValue: '',
        }, () => {

          this.props.fetchAssociatebyLocation(this.state.locationValue)
          .then((respData) => {
            // this.props.storeslocationsSave(respData.users);

            let updatedAssociateOptions = [
              { display: 'SALES ASSOCIATE*', value: '' },
            ];

            for(let i = 0; i < respData.users.length; i++) {
              let singleUser = {
                display: respData.users[i].first_name + ' ' + respData.users[i].last_name,
                value: respData.users[i].id,
              };
              updatedAssociateOptions.push(singleUser);
            }
            this.setState({ associateOptions: updatedAssociateOptions });

          })
          .catch((errorResp) => {
            console.error(errorResp);
          });
        });
      } else {

        let associateOptions = [
          { display: 'Sales Associate (please select location first)', value: '' },
        ];

        this.setState({ 
          associateOptions: associateOptions,
          associateValue: '',
        });
      }
    });
  }

  updateAssociates(location_id) {

    if(location_id === '' || location_id === null) {
      return;
    }

    // Fetch location associates
    let associateOptions = [
      { display: 'Loading...', value: '' },
    ];

    this.setState({ 
      associateOptions: associateOptions,
      associateValue: '',
    }, () => {

      this.props.fetchAssociatebyLocation(location_id)
      .then((respData) => {
        // this.props.storeslocationsSave(respData.users);

        let updatedAssociateOptions = [
          { display: 'SALES ASSOCIATE*', value: '' },
        ];

        for(let i = 0; i < respData.users.length; i++) {
          let singleUser = {
            display: respData.users[i].first_name + ' ' + respData.users[i].last_name,
            value: respData.users[i].id,
          };
          updatedAssociateOptions.push(singleUser);
        }

        if(this.props.users.cardToEdit && this.props.users.cardToEdit.associate_id) {
          this.setState({ 
            associateOptions: updatedAssociateOptions,
            associateValue: this.props.users.cardToEdit.associate_id,
          });
        } else {
          this.setState({ 
            associateOptions: updatedAssociateOptions,
          });
        }

      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    });
  }

  changeSalesAssociate(evt) {
    this.setState({associateValue: evt.target.value}, () => {
      if(this.state.associateError !== null && this.state.associateValue !== '') {
        this.setState({associateError: null});
      }
    });
  }

  changeFirstName(evt) {
    this.setState({ firstNameValue: evt.target.value }, () => {
      if(this.state.firstNameError && !nameValidation(this.state.firstNameValue)) {
        this.setState({ firstNameError: null });
      }
    });
  }

  changeLastName(evt) {
    this.setState({ lastNameValue: evt.target.value }, () => {
      if(this.state.lastNameError && !nameValidation(this.state.lastNameValue)) {
        this.setState({ lastNameError: null });
      }
    });
  }

  changeSoFirstName(evt) {
    this.setState({ soFirstNameValue: evt.target.value }, () => {
      if(this.state.soFirstNameError && !nameValidation(this.state.soFirstNameValue)) {
        this.setState({ soFirstNameError: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ phoneValue: displayPhoneInput(evt.target.value) }, () => {
      if(this.state.phoneError && !phoneValidation(this.state.phoneValue)) {
        this.setState({ phoneError: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ emailValue: evt.target.value }, () => {
      if(this.state.emailError && !emailValidation(this.state.emailValue)) {
        this.setState({ emailError: null });
      }
    });
  }

  changeOpt(evt) {
    this.setState({ optValue: !this.state.optValue });
  }

  changeAddressStreet(evt) {
    this.setState({ addressStreetValue: evt.target.value }, () => {
      if(this.state.addressStreetError && !streetValidation(this.state.addressStreetValue)) {
        this.setState({ addressStreetError: null });
      }
    });
  }

  changeAddressCity(evt) {
    this.setState({ addressCityValue: evt.target.value }, () => {
      if(this.state.addressCityError && !cityValidation(this.state.addressCityValue)) {
        this.setState({ addressCityError: null });
      }
    });
  }

  changeAddressState(evt) {
    this.setState({ addressStateValue: evt.target.value });
  }

  changeAddressZip(evt) {
    this.setState({ addressZipValue: evt.target.value }, () => {
      if(this.state.addressZipError && !zipValidation(this.state.addressZipValue)) {
        this.setState({ addressZipError: null });
      }
    });
  }

  changeBirthday(evt) {
    this.setState({ birthdayValue: displayDateInput(evt.target.value) }, () => {
      if(this.state.birthdayError && !dateValidation(this.state.birthdayValue)) {
        this.setState({ birthdayError: null });
      }
    });
  }

  changeSoBirthday(evt) {
    this.setState({ soBirthdayValue: displayDateInput(evt.target.value) }, () => {
      if(this.state.soBirthdayError && !dateValidation(this.state.soBirthdayValue)) {
        this.setState({ soBirthdayError: null });
      }
    });
  }

  changeWeddingDate(evt) {
    this.setState({ weddingDateValue: displayDateInput(evt.target.value) }, () => {
      if(this.state.weddingDateError && !dateValidation(this.state.weddingDateValue)) {
        this.setState({ weddingDateError: null });
      }
    });
  }

  changeHearAbout(evt) {
    this.setState({hearAboutValue: evt.target.value}, () => {
      if(this.state.hearAboutError !== null && evt.target.value !== '') {
        this.setState({hearAboutError: null});
      }
    });
  }

  changeReferral(evt) {
    this.setState({ referralValue: evt.target.value }, () => {
      if(this.state.referralError && !nameValidation(this.state.referralValue)) {
        this.setState({ referralError: null });
      }
    });
  }

  changeFingerSize(evt) {
    this.setState({fingerSizeValue: evt.target.value}, () => {
      if(this.state.fingerSizeError !== null && evt.target.value !== '') {
        this.setState({fingerSizeError: null});
      }
    });
  }

  changeSoFingerSize(evt) {
    this.setState({soFingerSizeValue: evt.target.value}, () => {
      if(this.state.soFingerSizeError !== null && evt.target.value !== '') {
        this.setState({soFingerSizeError: null});
      }
    });
  }

  changeNotes(evt) {
    this.setState({ notesValue: evt.target.value }, () => {
      if(this.state.notesError && !textValidation(this.state.notesValue)) {
        this.setState({ notesError: null });
      }
    });
  }

  validateFirstName(evt) {
    this.setState({ firstNameError: nameValidation(evt.target.value) });
  }

  validateLastName(evt) {
    this.setState({ lastNameError: nameValidation(evt.target.value) });
  }

  validateSoFirstName(evt) {
    if(this.state.soFirstNameValue) {
      this.setState({ soFirstNameError: nameValidation(evt.target.value) });
    }
  }

  validatePhone(evt) {
    this.setState({ phoneError: phoneValidation(evt.target.value) });
  }

  validateEmail(evt) {
    this.setState({ emailError: emailValidation(evt.target.value) });
  }

  validateAddressStreet(evt) {
    if(this.state.addressStreetValue) {
      this.setState({ addressStreetError: streetValidation(evt.target.value) });
    }
  }

  validateAddressCity(evt) {
    if(this.state.addressCityValue) {
      this.setState({ addressCityError: cityValidation(evt.target.value) });
    }
  }

  validateAddressZip(evt) {
    if(this.state.addressZipValue) {
      this.setState({ addressZipError: zipValidation(evt.target.value) });
    }
  }

  validateBirthday(evt) {
    if(this.state.birthdayValue) {
      this.setState({ birthdayError: dateValidation(evt.target.value) });
    }
  }

  validateSoBirthday(evt) {
    if(this.state.soBirthdayValue) {
      this.setState({ soBirthdayError: dateValidation(evt.target.value) });
    }
  }

  validateWeddingDate(evt) {
    if(this.state.weddingDateValue) {
      this.setState({ weddingDateError: dateValidation(evt.target.value) });
    }
  }

  validateReferral(evt) {
    if(this.state.referralValue) {
      this.setState({ referralError: nameValidation(evt.target.value) });
    }
  }

  validateNotes(evt) {
    if(this.state.notesValue) {
      this.setState({ notesError: textValidation(evt.target.value) });
    }
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let locationError = this.props.users.cardToEdit && this.props.users.cardToEdit.customer ? null : selectValidation(this.state.locationValue);
    // let associateError = selectValidation(this.state.associateValue);
    let firstNameError = nameValidation(this.state.firstNameValue);
    let lastNameError = nameValidation(this.state.lastNameValue);
    let emailError = emailValidation(this.state.emailValue);
    let phoneError = phoneValidation(this.state.phoneValue);

    // Changes from adding customer sync
    let associateError = null;

    // Optional params
    let soFirstNameError = null;
    if(this.state.soFirstNameValue) {
      soFirstNameError = nameValidation(this.state.soFirstNameValue);
    }

    let addressStreetError = null;
    if(this.state.addressStreetValue) {
      addressStreetError = streetValidation(this.state.addressStreetValue);
    }

    let addressCityError = null;
    if(this.state.addressCityValue) {
      addressCityError = cityValidation(this.state.addressCityValue);
    }

    let addressZipError = null;
    if(this.state.addressZipValue) {
      addressZipError = zipValidation(this.state.addressZipValue);
    }

    let referralError = null;
    // if(this.state.referralValue) {
    //   referralError = nameValidation(this.state.referralValue);
    // }

    let notesError = null;
    // if(this.state.notesValue) {
    //   notesError = textValidation(this.state.notesValue);
    // }

    if(locationError === null &&
       associateError === null &&
       firstNameError === null &&
       lastNameError === null &&
       emailError === null &&
       phoneError === null &&
       soFirstNameError === null &&
       addressStreetError === null &&
       addressCityError === null &&
       addressZipError === null &&
       referralError === null &&
       notesError === null) {
      hasErrors = false;
    }

    this.setState({
      locationError: locationError,
      associateError: associateError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      soFirstNameError: soFirstNameError,
      phoneError: phoneError,
      emailError: emailError,
      addressStreetError: addressStreetError,
      addressCityError: addressCityError,
      addressStateError: null,
      addressZipError: addressZipError,
      birthdayError: null,
      soBirthdayError: null,
      weddingDateError: null,
      hearAboutError: null,
      referralError: referralError,
      fingerSizeError: null,
      soFingerSizeError: null,
      notesError: notesError,
    });

    return !hasErrors;
  }

  clearState() {
    this.setState({
      successAlertOpen: true,
      sendingRequest: false,
      serverError: null,
      // locationOptions: locationOptions,
      // associateOptions: associateOptions,
      // stateOptions: stateOptions,
      // hearAboutOptions: hearAboutOptions,
      // customerSizeOptions: customerSizeOptions,
      // soSizeOptions: soSizeOptions,
      locationValue: '',
      associateValue: '',
      firstNameValue: '',
      lastNameValue: '',
      soFirstNameValue: '',
      phoneValue: '',
      emailValue: '',
      addressStreetValue: '',
      addressCityValue: '',
      addressStateValue: '',
      addressZipValue: '',
      birthdayValue: '',
      soBirthdayValue: '',
      weddingDateValue: '',
      hearAboutValue: '',
      referralValue: '',
      fingerSizeValue: '',
      soFingerSizeValue: '',
      notesValue: '',
      optValue: false, 
      locationError: null,
      associateError: null,
      firstNameError: null,
      lastNameError: null,
      soFirstNameError: null,
      phoneError: null,
      emailError: null,
      addressStreetError: null,
      addressCityError: null,
      addressStateError: null,
      addressZipError: null,
      birthdayError: null,
      soBirthdayError: null,
      weddingDateError: null,
      hearAboutError: null,
      referralError: null,
      fingerSizeError: null,
      soFingerSizeError: null,
      notesError: null,
    });
  }

  async handleSubmit() {
    if(this.validateAll()) {

      const store_num = this.getAscIdByDbId(this.state.locationValue) ? this.getAscIdByDbId(this.state.locationValue) : 1;

      const cardData = {
        id: this.state.idValue,
        store_num: store_num,
        // associate_id: this.state.associateValue,
        first_name: this.state.firstNameValue,
        last_name: this.state.lastNameValue,
        email: this.state.emailValue,
        phone_number: stringToDigits(this.state.phoneValue),
        so_first_name: this.state.soFirstNameValue === '' ? null : this.state.soFirstNameValue,
        street: this.state.addressStreetValue === '' ? null : this.state.addressStreetValue,
        city: this.state.addressCityValue === '' ? null : this.state.addressCityValue,
        state: this.state.addressStateValue === '' ? null : this.state.addressStateValue,
        zip: this.state.addressZipValue === '' ? null : this.state.addressZipValue,
        birthday: this.state.birthdayValue === '' ? null : this.state.birthdayValue.replace('/', ''),
        so_birthday: this.state.soBirthdayValue === '' ? null : this.state.soBirthdayValue.replace('/', ''),
        anniversary: this.state.weddingDateValue === '' ? null : this.state.weddingDateValue.replace('/', ''),
        // hear_about: this.state.hearAboutValue === '' ? null : this.state.hearAboutValue,
        // referral_name: this.state.referralValue === '' ? null : this.state.referralValue,
        finger_size: this.state.fingerSizeValue === '' ? null : this.state.fingerSizeValue,
        so_finger_size: this.state.soFingerSizeValue === '' ? null : this.state.soFingerSizeValue,
        // notes: this.state.notesValue === '' ? null : this.state.notesValue,
        auth_token: this.authToken,
        opt_out: this.state.optValue,
      }

      this.setState({
        sendingRequest: true,
        serverError: null,
      });

      let addingCustomer = this.state.idValue === null;

      let cardResp = null;
      if(addingCustomer) {
        cardResp = await this.props.userCustomerCreate(cardData)
          .catch((errResp) => {
            console.error(errResp);
            this.setState({
              sendingRequest: false,
            });
            if(errResp && errResp.ip) {
              this.props.commonAlert('Please connect to a Diamonds Direct store network to add a customer');
            } else if(errResp && errResp.code === 411) {
              this.props.commonAlert("A customer with that email address already exists.", {
                linkLabel: 'See matching customers',
                linkSrc: '/leads?email=' + cardData.email,
              });
            } else if(errResp && errResp.code === 436) {
              this.props.commonAlert("A customer with that phone number already exists.", {
                linkLabel: 'See matching customers',
                linkSrc: '/leads?phone_number=' + cardData.phone_number,
              });
            }
          })
      } else {
        cardResp = await this.props.userCustomerUpdate(cardData)
          .catch((errResp) => {
            console.error(errResp);
            this.setState({
              sendingRequest: false,
            });
            if(errResp && errResp.ip) {
              this.props.commonAlert('Please connect to a Diamonds Direct store network to complete your edit');
            } else if(errResp && errResp.code === 411) {
              this.props.commonAlert("A customer with that email address already exists.", {
                linkLabel: 'See matching customers',
                linkSrc: '/leads?email=' + cardData.email,
              });
            } else if(errResp && errResp.code === 436) {
              this.props.commonAlert("A customer with that phone number already exists.", {
                linkLabel: 'See matching customers',
                linkSrc: '/leads?phone_number=' + cardData.phone_number,
              });
            }
          })
      }

      if(!cardResp) {
        return null;
      }

      this.clearState();

      let alertText = "Customer has been updated. Please allow 10-15 minutes for this data to be synced with ASC before it can be seen in the app.";
      if(addingCustomer) {
        alertText = "Customer has been created. Please allow 10-15 minutes for this data to be synced with ASC before it can be seen in the app.";
      }

      this.props.commonAlert(alertText);
      history.push('/leads');
    }
  }

  diamondsNav() {
    if(this.props.users.returnTo === null) {
      history.push('/diamonds');
    } else {
      history.push(this.props.users.returnTo);
      setTimeout(() => {
        this.props.usersSetReturnTo(null);
      }, 50);
    }
    this.setState({ successAlertOpen: false });
  }

  shareNav() {
    // history.push('/');
    this.setState({ successAlertOpen: false });
  }

  viewNav() {

    let backToCard = this.props.users.cardToEdit !== null || this.props.users.customerCard !== null;
    let backToEmail = this.props.users.cardToEdit !== null ? this.props.users.cardToEdit.email_address : null;
    backToEmail = this.props.users.customerCard !== null ? this.props.users.customerCard.email_address : backToEmail;

    this.props.setCustomerCardToEdit(null);

    if(backToCard) {
      history.push('/customer/view/' + encodeURIComponent(backToEmail));
    } else {
      history.push('/leads');
    }
  }

  closeProfile() {
    window.history.back();
  }

  resetSearch(evt) {

    evt.stopPropagation();

    let associateOptions = [
      { display: 'Sales Associate (please select location first)', value: '' },
    ];

    this.setState({
      successAlertOpen: false,
      sendingRequest: false,
      serverError: null,
      // locationOptions: locationOptions,
      associateOptions: associateOptions,
      // stateOptions: stateOptions,
      // hearAboutOptions: hearAboutOptions,
      // customerSizeOptions: customerSizeOptions,
      // soSizeOptions: soSizeOptions,
      locationValue: '',
      associateValue: '',
      firstNameValue: '',
      lastNameValue: '',
      soFirstNameValue: '',
      phoneValue: '',
      emailValue: '',
      addressStreetValue: '',
      addressCityValue: '',
      addressStateValue: '',
      addressZipValue: '',
      birthdayValue: '',
      soBirthdayValue: '',
      weddingDateValue: '',
      hearAboutValue: '',
      referralValue: '',
      fingerSizeValue: '',
      soFingerSizeValue: '',
      notesValue: '',
      locationError: null,
      associateError: null,
      firstNameError: null,
      lastNameError: null,
      soFirstNameError: null,
      phoneError: null,
      emailError: null,
      addressStreetError: null,
      addressCityError: null,
      addressStateError: null,
      addressZipError: null,
      birthdayError: null,
      soBirthdayError: null,
      weddingDateError: null,
      hearAboutError: null,
      referralError: null,
      fingerSizeError: null,
      soFingerSizeError: null,
      notesError: null, 
    });
  }

	render() {
		return <div className='CustomerProfile'>
      <div className={isLoggedIn() ? 'pageCloseIcon' : 'pageCloseIcon loggedOut'} onClick={this.closeProfile.bind(this)}>&times;</div>
      <div className='customerProfileTitle'>{this.props.users.cardToEdit ? 'Edit Customer' : 'Create Customer'}</div>
      <div className="formWrapper">
        <div className={'customerInput halfWidth'} style={{display: !this.props.users.cardToEdit || isGM() ? 'inline-block' : 'none'}}>
          <RhinoSelect
            selectClass={this.state.locationError ? 'profileSelect error' : 'profileSelect'}
            required={true}
            value={this.state.locationValue} 
            options={this.state.locationOptions}
            changeMethod={(evt) => this.changeLocation(evt)}
            error={this.state.locationError} />
        </div>
        <div className={'customerInput halfWidth'} style={{display: (!this.props.users.cardToEdit || isGM()) && false ? 'inline-block' : 'none'}}>
          <RhinoSelect
            selectClass={this.state.associateError ? 'profileSelect error' : 'profileSelect'}
            required={true}
            value={this.state.associateValue} 
            disabled={this.state.locationValue === ''}
            options={this.state.associateOptions}
            changeMethod={(evt) => this.changeSalesAssociate(evt)}
            error={this.state.associateError} />
        </div>
        <div className='sectionHeader'>Customer Name*</div>
        <div className={'customerInput halfWidth'}>
          <input
            type='text' 
            placeholder = 'FIRST NAME'
            className={this.state.firstNameError ? 'profileInput error' : 'profileInput'}
            value={this.state.firstNameValue} 
            onChange={this.changeFirstName.bind(this)} 
            onBlur={this.validateFirstName.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'}>
          <input
            type='text' 
            placeholder = 'LAST NAME'
            className={this.state.lastNameError ? 'profileInput error' : 'profileInput'}
            value={this.state.lastNameValue} 
            onChange={this.changeLastName.bind(this)} 
            onBlur={this.validateLastName.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'}>
          <input
            type='tel' 
            placeholder = 'CUSTOMER PHONE #*'
            className={this.state.phoneError ? 'profileInput error' : 'profileInput'}
            value={this.state.phoneValue} 
            onChange={this.changePhone.bind(this)} 
            onBlur={this.validatePhone.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'}>
          <input
            type='text' 
            placeholder = 'CUSTOMER EMAIL*'
            className={this.state.emailError ? 'profileInput error' : 'profileInput'}
            value={this.state.emailValue} 
            onChange={this.changeEmail.bind(this)} 
            onBlur={this.validateEmail.bind(this)} />
          <div className='optWrapper' style={{ display: 'none' }}>
            <div className='checkboxWrapper'>
              <input 
                type='checkbox'
                name='opt'
                checked={this.state.optValue}
                onChange={this.changeOpt} />
            </div>
            <div className='labelWrapper'>Opt Out</div>
          </div>
        </div>
        <div className='sectionHeader'>Significant Other Name</div>
        <div className={'customerInput halfWidth'}>
          <input
            type='text' 
            placeholder = 'SIGNIFICANT OTHER'
            className={this.state.soFirstNameError ? 'profileInput error' : 'profileInput'}
            value={this.state.soFirstNameValue} 
            onChange={this.changeSoFirstName.bind(this)} 
            onBlur={this.validateSoFirstName.bind(this)} />
        </div>
        <div className='sectionHeader'>Address</div>
        <div className={'customerInput halfWidth'}>
          <input
            type='text' 
            placeholder = 'ADDRESS'
            className={this.state.addressStreetError ? 'profileInput error' : 'profileInput'}
            value={this.state.addressStreetValue} 
            onChange={this.changeAddressStreet.bind(this)} 
            onBlur={this.validateAddressStreet.bind(this)} />
        </div>
        <div className={'customerInput halfWidth mobileVisible'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'CITY'
            className={this.state.addressCityError ? 'profileInput error' : 'profileInput'}
            value={this.state.addressCityValue} 
            onChange={this.changeAddressCity.bind(this)} 
            onBlur={this.validateAddressCity.bind(this)} />
        </div>
        <div className={'customerInput halfWidth mobileVisible'}>
          <div className={'quarterWidth'} style={{ display: 'none' }}>
            <RhinoSelect
              selectClass={this.state.addressStateError ? 'profileSelect error' : 'profileSelect'}
              required={false}
              value={this.state.addressStateValue} 
              options={this.state.stateOptions}
              changeMethod={(evt) => this.changeAddressState(evt)}
              error={this.state.addressStateError} />
          </div>
          <div className={'quarterWidth'} style={{ display: 'none' }}>
            <input
              type='text' 
              placeholder = 'ZIP CODE'
              className={this.state.addressZipError ? 'profileInput error' : 'profileInput'}
              value={this.state.addressZipValue} 
              onChange={this.changeAddressZip.bind(this)} 
              onBlur={this.validateAddressZip.bind(this)} />
          </div>
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'CUSTOMER BIRTHDAY (MM/DD)'
            className={this.state.birthdayError ? 'profileInput error' : 'profileInput'}
            value={this.state.birthdayValue} 
            onChange={this.changeBirthday.bind(this)} 
            onBlur={this.validateBirthday.bind(this)} />
        </div>
        <div className={'customerInput halfWidth desktopVisible'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'CITY'
            className={this.state.addressCityError ? 'profileInput error' : 'profileInput'}
            value={this.state.addressCityValue} 
            onChange={this.changeAddressCity.bind(this)} 
            onBlur={this.validateAddressCity.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'SIGNIFICANT OTHER BIRTHDAY (MM/DD)'
            className={this.state.soBirthdayError ? 'profileInput error' : 'profileInput'}
            value={this.state.soBirthdayValue} 
            onChange={this.changeSoBirthday.bind(this)} 
            onBlur={this.validateSoBirthday.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'WEDDING / ANNIVERSARY DATE (MM/DD)'
            className={this.state.weddingDateError ? 'profileInput error' : 'profileInput'}
            value={this.state.weddingDateValue} 
            onChange={this.changeWeddingDate.bind(this)} 
            onBlur={this.validateWeddingDate.bind(this)} />
        </div>
        <div className={'customerInput halfWidth desktopVisible'}>
          <div className={'quarterWidth'} style={{ display: 'none' }}>
            <RhinoSelect
              selectClass={this.state.addressStateError ? 'profileSelect error' : 'profileSelect'}
              required={false}
              value={this.state.addressStateValue} 
              options={this.state.stateOptions}
              changeMethod={(evt) => this.changeAddressState(evt)}
              error={this.state.addressStateError} />
          </div>
          <div className={'quarterWidth'} style={{ display: 'none' }}>
            <input
              type='text' 
              placeholder = 'ZIP CODE'
              className={this.state.addressZipError ? 'profileInput error' : 'profileInput'}
              value={this.state.addressZipValue} 
              onChange={this.changeAddressZip.bind(this)} 
              onBlur={this.validateAddressZip.bind(this)} />
          </div>
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <RhinoSelect
            selectClass={this.state.hearAboutError ? 'profileSelect error' : 'profileSelect'}
            required={false}
            value={this.state.hearAboutValue} 
            options={this.state.hearAboutOptions}
            changeMethod={(evt) => this.changeHearAbout(evt)}
            error={this.state.hearAboutError} />
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <input
            type='text' 
            placeholder = 'REFERRAL NAME (IF APPLICABLE)'
            className={this.state.referralError ? 'profileInput error' : 'profileInput'}
            value={this.state.referralValue} 
            onChange={this.changeReferral.bind(this)} 
            onBlur={this.validateReferral.bind(this)} />
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <RhinoSelect
            selectClass={this.state.fingerSizeError ? 'profileSelect error' : 'profileSelect'}
            required={false}
            value={this.state.fingerSizeValue} 
            options={this.state.customerSizeOptions}
            changeMethod={(evt) => this.changeFingerSize(evt)}
            error={this.state.fingerSizeError} />
        </div>
        <div className={'customerInput halfWidth'} style={{ display: 'none' }}>
          <RhinoSelect
            selectClass={this.state.soFingerSizeError ? 'profileSelect error' : 'profileSelect'}
            required={false}
            value={this.state.soFingerSizeValue} 
            options={this.state.soSizeOptions}
            changeMethod={(evt) => this.changeSoFingerSize(evt)}
            error={this.state.soFingerSizeError} />
        </div>
        <div className={'customerInput fullWidth'} style={{ display: 'none' }}>
          <textarea
            type='text' 
            placeholder = 'NOTES'
            className={this.state.notesError ? 'profileTextarea error' : 'profileTextarea'}
            onChange={this.changeNotes.bind(this)} 
            value={this.state.notesValue}
            onBlur={this.validateNotes.bind(this)}></textarea>
        </div>
        <div className={'customerInput fullWidth'}>
          <div className={'loginSubmit bottomAction refreshIcon'} onClick={this.handleSubmit.bind(this)}>
            Save
            <div className='iconWrapper' onClick={this.resetSearch.bind(this)}>
              <img src='/img/icons/reset.svg' />
            </div>
          </div>
          <div className='bottomActionSpacer'></div>
        </div>
      </div>
      <CustomerCardSubmit 
        open={this.state.successAlertOpen} 
        viewNav={this.viewNav.bind(this)}
        shareNav={this.shareNav.bind(this)}
        diamondsNav={this.diamondsNav.bind(this)} />
    </div>;
	}
}
export default CustomerProfile;

function mapStateToProps(state) {
  return {
    leads: state.leads,
    stores: state.stores,
    users: state.users,
  };
}

export const CustomerProfileContainer = connect(
  mapStateToProps,
  allActionCreators
)(CustomerProfile);